<template>
	<div>
		<b-row class="mt-3">
			<b-col md="4">
				<b-form inline @submit.prevent="searchContract">
					<b-form-group>
						<b-input type="text" v-model="currentSearch" />

						<b-button type="submit" variant="outline-success">Search</b-button>

						<b-button v-if="searchFlag" @click.prevent="clearSearch" variant="outline-danger">Clear</b-button>
					</b-form-group>
				</b-form>
			</b-col>
		</b-row>

		<b-row class="mt-3">
			<b-col md="12">
				<b-table-simple bordered>
					<b-thead head-variant="light">
						<tr>
							<th style="width: 150px">
								<a href="#" @click.prevent="sort('Reference')">
									Ref
									<b-icon font-scale="1.5" class="ml-3" v-if="currentSort == 'Reference' &&
										currentSortDir == 'asc'
										" icon="chevron-compact-up"></b-icon>
									<b-icon font-scale="1.5" class="ml-3" v-else-if="currentSort == 'Reference' &&
										currentSortDir == 'desc'
										" icon="chevron-compact-down"></b-icon>
									<b-icon font-scale="1.5" class="ml-3" v-else icon="arrow-up-down"></b-icon>
								</a>
							</th>

							<th>
								<a href="#" @click.prevent="sort('Customer')">
									Customer
									<b-icon font-scale="1.5" class="ml-3" v-if="currentSort ==
										'Customer' &&
										currentSortDir == 'asc'
										" icon="chevron-compact-up"></b-icon>
									<b-icon font-scale="1.5" class="ml-3" v-else-if="currentSort ==
										'Customer' &&
										currentSortDir == 'desc'
										" icon="chevron-compact-down"></b-icon>
									<b-icon font-scale="1.5" class="ml-3" v-else icon="arrow-up-down"></b-icon>
								</a>
							</th>


							<th>Clocks</th>

							<th style="width: 150px">
								<a href="#" @click.prevent="sort('InvoiceCode')">
									Code
									<b-icon font-scale="1.5" class="ml-3" v-if="currentSort ==
										'InvoiceCode' &&
										currentSortDir == 'asc'
										" icon="chevron-compact-up"></b-icon>
									<b-icon font-scale="1.5" class="ml-3" v-else-if="currentSort ==
										'InvoiceCode' &&
										currentSortDir == 'desc'
										" icon="chevron-compact-down"></b-icon>
									<b-icon font-scale="1.5" class="ml-3" v-else icon="arrow-up-down"></b-icon>
								</a>
							</th>

							<th style="width: 150px">Status</th>

						</tr>
					</b-thead>

					<b-tbody>
						<contract-list-row v-for="contract in contracts" :key="contract.Id" :contract="contract" @update="updateContract" />
					</b-tbody>
				</b-table-simple>
			</b-col>
		</b-row>

		<!-- <b-row class="mt-3">
		
			<b-col cols="4" offset="4">			
				<b-pagination first-number last-number v-model="paging.currentPage" :total-rows="paging.totalCount" :per-page="paging.pageSize" @input="fetchContracts" limit="6" align="fill"></b-pagination> 
			</b-col>

			<b-col cols="1">
				<b-form-input debounce="1000" min="1" v-model="paging.currentPage" :max="paging.totalPages" type="number" @input="fetchContracts"></b-form-input>				
			</b-col>

		</b-row> -->

		<div class="d-flex justify-content-center mb-5">
			<b-pagination
				first-number
				last-number
				v-model="paging.currentPage"
				:total-rows="paging.totalCount"
				:per-page="paging.pageSize"
				@input="fetchContracts"
				limit="7"
				class="mr-3"
			></b-pagination> 
			<b-form-input
				debounce="1000"
				min="1"
				v-model="paging.currentPage"
				:max="paging.totalPages"
				type="number"
				@input="fetchContracts"
				style="width:100px;"
			></b-form-input>
		</div>

	</div>
</template>

<script>
import ContractService from '@/api-services/contract.service';
import ContractListRow from '@/components/contract/contract-list-row';

export default {
	name: 'ContractList',

	components: {
		ContractListRow
	},

	data() {
		return {
			contracts: [],

			selectedContractId: null,

			currentSort: 'Reference',
			currentSortDir: 'asc',

			currentSearch: '',
			searchFlag: false,

			paging: {
				currentPage:
					this.$route.query.p == null
						? 1
						: parseInt(this.$route.query.p),
				pageSize: 50,
				totalCount: 999,
				totalPages: 30
			}
		};
	},

	mounted() {
		this.urlReadState();

		
	},

	methods: {
		sort(s) {
			//if s == current sort, reverse
			if (s === this.currentSort) {
				this.currentSortDir =
					this.currentSortDir === 'asc' ? 'desc' : 'asc';
			}
			this.currentSort = s;
			this.fetchContracts();
		},

		fetchContracts() {
			ContractService.getPaged(
				this.paging.pageSize,
				this.paging.currentPage,
				this.currentSort,
				this.currentSortDir
			)
				.then(response => {
					Object.assign(
						this.paging,
						JSON.parse(response.headers['paging-headers'])
					);

					this.contracts = response.data;

					this.urlPushState();
				})
				.catch(error => {
					console.log('not authorized');
				});
		},

		clearSearch() {
			if (this.searchFlag) {
				this.currentSearch = '';
				this.searchFlag = false;
				this.resetPaging();
				this.fetchContracts();
			}
		},

		searchContract() {
			if (this.currentSearch != '') {
				this.resetPaging();
				ContractService.search(this.currentSearch).then(response => {
					Object.assign(
						this.paging,
						JSON.parse(response.headers['paging-headers'])
					);
					this.contracts = response.data;
					this.urlPushState();
					this.searchFlag = true;
				});
			}
		},

		urlReadState() {
			let urlSort = this.$route.query.s;
			let urlSortDir = this.$route.query.d;
			let urlSearch = this.$route.query.q;

			if (urlSort || urlSortDir) {
				this.currentSortDir = (urlSortDir === undefined) ? '' : urlSortDir;
				this.currentSort = (urlSort === undefined) ? this.currentSort : urlSort;
			}

			if (urlSearch) {
				this.currentSearch = (urlSearch === undefined) ? '' : urlSearch;
				this.searchContract();
			} else {

				this.fetchContracts();
				
			}
		},

		urlPushState() {
			if (history.pushState) {

				var urlParams = new URLSearchParams(window.location.search);

				if (this.paging.currentPage > 1) {
					urlParams.set('p', this.paging.currentPage);
				} else {
					urlParams.delete('p');
				}

				if (this.currentSort != 'Reference') {
					urlParams.set('s', this.currentSort);
				} else {
					urlParams.delete('s');
				}

				if (this.currentSortDir != 'asc') {
					urlParams.set('d', this.currentSortDir);
				} else {
					urlParams.delete('d');
				}

				if (this.currentSearch != '') {
					urlParams.set('q', this.currentSearch);
				} else {
					urlParams.delete('q');
				}

				let origin = new URLSearchParams(window.location.search);

				if (JSON.stringify(Array.from(urlParams)) !== JSON.stringify(Array.from(origin))) {

					var newurl =
						window.location.protocol +
						'//' +
						window.location.host +
						window.location.pathname +
						'?' +
						urlParams;
					window.history.pushState({ path: newurl }, '', newurl);
				}
			}
		},

		resetPaging() {
			this.paging = {
				currentPage: 1,
				pageSize: 50,
				totalCount: 999,
				totalPages: 30
			};
		},

		updateContract(contractId) {
			this.$router.push({
				name: 'contractupdate',
				params: { id: contractId }
			});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/contract/contract-list.vue